/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'app-job-category-update-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './job-category-update-dialog.component.html',
  styleUrls: ['./job-category-update-dialog.component.scss'],
})
export class JobCategoryUpdateDialogComponent implements OnInit {

  updateJobCategoryAction: string = 'UPDATE';

  constructor(
    public matDialogRef: MatDialogRef<JobCategoryUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public utilityService: UtilityService
  ) { }

  closeModal(): void {
    this.matDialogRef.close();
  }

  updateCategory(): void {
    this.matDialogRef.close({category: this.updateJobCategoryAction});
  }


  ngOnInit(): void {
  }

}
